import SiteConfig from '@/services/SiteConfig'

export const COLLECTION_PAGE_API_URL =
  SiteConfig.apiRoot + 'v2/collection-page-sites/'

export const ASSET_DOWNLOAD_URL = SiteConfig.apiRoot + 'v2/assets/'

export const COLLECTION_ROUTE_NAME = 'collection'

export const SEARCH_COLLECTION_PAGE_PATH = '/text-search-col-c9999'
